import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import PageTitle from '../../components/PageTitle';
import { connect } from 'react-redux';
import styled from 'styled-components';
import SalesChannel from './components/SalesChannel';
import ShippingPartner from './components/ShippingPartner';
import PaymentMethod from './components/PaymentMethod';
import VNPayTerminal from './components/VNPayTerminal';

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const SettingAdvanced: React.FC<Props> = (props: any) => {
    const {user} = props
    useEffect(() => {
        document.title = 'Cấu hình nâng cao'
    }, []);

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: `Cấu hình nâng cao`, active: true },
                    ]}
                    title={`Cấu hình nâng cao`}
                />
                <PageContent>
                    <Row>
                        <Col md={6} xs={12}>
                            <SalesChannel {...props} />
                            <PaymentMethod {...props} />
                        </Col>
                        <Col md={6} xs={12}>
                            <ShippingPartner  {...props} />
                            <VNPayTerminal  {...props} />
                        </Col>
                    </Row>
                </PageContent>
            </React.Fragment>
        </div>
    );
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default connect(mapState)(SettingAdvanced)